import React from "react";
import { useContent } from "../context/ContentContext";

const buttonStyle = {
  position: "fixed",
  bottom: "24px",
  right: "24px",
  zIndex: 9999,
  backgroundColor: "#25D366",
  borderRadius: "50%",
  width: "60px",
  height: "60px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
  cursor: "pointer",
};

export default function WhatsAppButton() {
  const content = useContent();
  const company = content.getCompany();
  const whatsappNumber = company.phones?.[0] || "";
  return (
    <a
      href={whatsappNumber ? `https://wa.me/${whatsappNumber}` : undefined}
      target="_blank"
      rel="noopener noreferrer"
      style={buttonStyle}
      aria-label="Chat on WhatsApp"
    >
      <svg width="32" height="32" viewBox="0 0 32 32" fill="white">
        <path d="M16 3C9.373 3 4 8.373 4 15c0 2.65.87 5.1 2.36 7.1L4 29l7.13-2.34C13.06 27.55 14.5 28 16 28c6.627 0 12-5.373 12-12S22.627 3 16 3zm0 22c-1.3 0-2.58-.25-3.77-.74l-.27-.11-4.23 1.39 1.39-4.09-.18-.28C7.25 18.58 7 17.3 7 16c0-5.06 4.13-9.18 9.18-9.18 5.06 0 9.18 4.13 9.18 9.18S21.06 25 16 25zm5.13-7.47c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.19-.44-2.26-1.4-.84-.75-1.41-1.67-1.58-1.95-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.18-.28.28-.46.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47-.16-.01-.34-.01-.52-.01-.18 0-.48.07-.73.34-.25.28-.97.95-.97 2.3 0 1.35.99 2.66 1.13 2.85.14.18 1.95 2.98 4.73 4.06.66.28 1.18.45 1.58.58.66.21 1.26.18 1.73.11.53-.08 1.65-.67 1.88-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.18-.53-.32z"/>
      </svg>
    </a>
  );
}